export default __webpack_public_path__ + "static/media/ContentLibraryLightInActive.56aa3cb8.svg";